import clsx from 'clsx';
import styles from './styles.module.scss';
import { useEffect, useRef, useState } from 'react';

import * as Sentry from '@sentry/react';

type BottomSheetItemProps = {
  title: string;
  onClick: () => void;
  variant?: 'default' | 'danger';
  className?: string;
};

const BottomSheetItemFeedBack: React.FC<BottomSheetItemProps> = (props) => {
  const { title, onClick, variant, className } = props;
  const [isSetRef, setIsSetRef] = useState(false);
  const refFeedback = useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (refFeedback.current !== null && !isSetRef) {
      setIsSetRef(true);
    }
  }, [refFeedback.current]);

  useEffect(() => {
    if (isSetRef && refFeedback.current) {
      Sentry.getFeedback()?.attachTo(refFeedback.current);
    }
  }, [isSetRef]);

  return (
    <li
      ref={refFeedback}
      className={clsx(styles.item, variant === 'danger' && styles.danger, className)}
      onClick={onClick}
    >
      {title}
    </li>
  );
};

export default BottomSheetItemFeedBack;
